import React from 'react';
import styles from "./index.module.scss";
import classNames from "classnames";
import { Col, Row } from "antd";

import { ReactComponent as Recycle } from './images/recycle-icon.svg';
import Haiti1 from "./images/haiti-21-a-0520.jpg"
import HpImg from "./images/hp-f-3-b-7853421-fb-3-deb-442-a-85142939-c-66-edf-6-ab-5-bd.jpg"
import Haiti2 from "./images/haiti-2-21-a-1310.jpg"
import HandsCartridges from "./images/hands-cartridges.jpg"
import Haiti3 from "./images/haiti-21-a-2114.jpg"
import SuppliesHome from "./images/20180820-04-supplies-home-b-j-5-a-1760.jpg"



let cx = classNames.bind(styles);

const Hero = (props) => (
    <div className={styles.recycle} id="recycle">
        <div className={styles.container}>
            <div className={styles.recycleIconContainer}>
                <Recycle className={styles.recycleIcon}/>
            </div>
            <div className={styles.header}>Better for the environment</div>
            <div className={styles.subHeader}>With Instant Ink you are collaborating to end ocean-plastic pollution.</div>
            
            <Row className={styles.bg}>
                <Col lg={10} xl={7} className={styles.textCol}>
                    <div className={styles.textContainer}>
                        <div className={styles.text}>
                            We recycle plastic bottles collected from the ocean and returned
                            Instant Ink cartridges, which are used to make new cartridges.
                            <br/><br/>
                            With Instant Ink, we use less packaging, which means less waste<sup onClick={(evt) => { document.getElementById('footnote-6').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"}); }}>6,7</sup>.
                        </div>
                    </div>
                </Col>
                <Col lg={14} xl={17} className={styles.imageCol}>
                    <Row type="flex" className={styles.imagesRow}>
                        <Col lg={12} xl={9}>
                            <img src={Haiti1}/>
                        </Col>
                        <Col lg={12} xl={7} className={styles.imgCol2}>
                            <img src={Haiti2}/>
                        </Col>
                        <Col lg={0} xl={7} className={styles.imgCol2}>
                            <img src={Haiti3}/>
                        </Col>
                    </Row>
                    <Row type="flex" className={styles.imagesRow}>
                        <Col lg={12} xl={9}>
                            <img src={HpImg}/>
                        </Col>
                        <Col lg={12} xl={7} className={styles.imgCol2}>
                            <img src={HandsCartridges}/>
                        </Col>
                        <Col lg={0} xl={7} className={styles.imgCol2}>
                            <img src={SuppliesHome}/>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    </div>
);

export default Hero;
